/* eslint-disable filename-rules/match */
import { useMemo, useContext } from 'react';
import { userContext } from 'context/user';

function useApplicationPermission() {
  const { currentUser } = useContext(userContext);
  const collabApplicationPermission =
    currentUser?.permissions && currentUser.permissions.length > 0
      ? currentUser.permissions[0]
      : null;

  const collabSuperAdminRole = useMemo(() => {
    if (collabApplicationPermission) {
      const collabUserRole = collabApplicationPermission.childSettings.find(
        (category) => category.settingName === 'Collaboration User',
      );
      if (collabUserRole) {
        return collabUserRole.childSettings.find(
          (category) => category.settingName === 'Super Admin',
        );
      }
    }
  }, [collabApplicationPermission]);

  const collabPlatformAdminRole = useMemo(() => {
    if (collabApplicationPermission) {
      const collabUserRole = collabApplicationPermission.childSettings.find(
        (category) => category.settingName === 'Collaboration User',
      );
      if (collabUserRole) {
        return collabUserRole.childSettings.find(
          (category) => category.settingName === 'Admin',
        );
      }
    }
  }, [collabApplicationPermission]);
  return {
    collabApplicationPermission,
    collabSuperAdminRole,
    collabPlatformAdminRole,
  };
}

export default useApplicationPermission;
